// Copyright 2020 TOKU Systems Inc.

import React, { useState } from 'react';
import AppBarWithMenu from '../app-bar-with-menu';
import { useHistory } from 'react-router-dom';
import * as _ from 'lodash';
import Timeline from './timeline';
import { clampDomain, SignalPlot, SignalCursorValue } from './signal-plot';
import { List, Map } from 'immutable';
import SignalsBar from './signal-bar';
import { Grid } from '@material-ui/core';
import { makeTimeDomain, lastDay } from './plot-domain';
import { DomainTuple } from 'victory-core';
import GraphSurface from './graph-surface';

interface PlotProps {
  title: string;
}

export default function Plot(props: PlotProps): JSX.Element {
  const [signalPlots, setSignalPlots] = useState<List<SignalPlot>>(List());
  const [timeDomain] = useState(makeTimeDomain({}));
  const [selectedDomain, setSelectedDomain] = useState(lastDay(timeDomain));
  const [cursorValues, setCursorValues] = useState(
    Map<string, SignalCursorValue>()
  );

  const history = useHistory();

  const handleSignalPlotsChange = (
    changedSignalPlots: List<SignalPlot>
  ): void => {
    setSignalPlots(changedSignalPlots);
  };

  const handleSelectedDomainChange = (domain: DomainTuple): void => {
    setSelectedDomain(clampDomain(domain));
  };

  const handleCursorValuesChange = (
    cursorValuesChange: Map<string, SignalCursorValue>
  ): void => {
    setCursorValues(cursorValuesChange);
  };

  return (
    <React.Fragment>
      <AppBarWithMenu
        title={_.get(history.location.state, ['title'], props.title)}
        showGoBack={true}
      />
      <Grid
        container
        direction="row"
        justify="space-evenly"
        alignItems="stretch"
        style={{
          top: '72px',
          width: '100vw',
          height: 'calc(100vh - 72px)',
        }}
      >
        <Grid item xs={12}>
          <SignalsBar
            originRefs={_.get(history.location.state, ['originRefs'], List())}
            cursorValues={cursorValues}
            onSignalPlotsChange={handleSignalPlotsChange}
          />
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            flexGrow: 1,
            height: 'calc(100vh - 220px - 72px)',
          }}
        >
          <GraphSurface
            onZoomDomainChange={handleSelectedDomainChange}
            onCursorValuesChange={handleCursorValuesChange}
            signalPlots={signalPlots}
            timeDomain={timeDomain}
            zoomDomain={selectedDomain}
          />
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            height: '120px',
          }}
        >
          <Timeline
            onBrushDomainChange={handleSelectedDomainChange}
            signalPlots={signalPlots}
            timeDomain={timeDomain}
            brushDomain={selectedDomain}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
